import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  id: "dropdown"
}, null, -1);
var _hoisted_2 = {
  "class": "md:flex md:flex-col"
};
var _hoisted_3 = {
  "class": "md:flex md:flex-col md:h-screen"
};
var _hoisted_4 = {
  "class": "md:flex md:flex-shrink-0"
};
var _hoisted_5 = {
  "class": "flex items-center justify-between px-6 py-4 bg-indigo-900 md:flex-shrink-0 md:justify-center md:w-56"
};
var _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  "class": "w-6 h-6 fill-white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"
})], -1);
var _hoisted_7 = {
  "class": "mt-2 px-8 py-4 bg-indigo-800 rounded shadow-lg"
};
var _hoisted_8 = {
  "class": "md:text-md flex items-center justify-between p-4 w-full text-sm bg-white border-b md:px-12 md:py-0"
};
var _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  "class": "mr-4 mt-1"
}, "Admin Portal", -1);
var _hoisted_10 = {
  "class": "group flex items-center cursor-pointer select-none"
};
var _hoisted_11 = {
  "class": "mr-1 text-gray-700 group-hover:text-indigo-600 focus:text-indigo-600 whitespace-nowrap"
};
var _hoisted_12 = {
  "class": "hidden md:inline"
};
var _hoisted_13 = {
  "class": "mt-2 py-2 text-sm bg-white rounded shadow-xl"
};
var _hoisted_14 = /*#__PURE__*/_createTextVNode("My Profile");
var _hoisted_15 = /*#__PURE__*/_createTextVNode("Manage Users");
var _hoisted_16 = /*#__PURE__*/_createTextVNode("Logout");
var _hoisted_17 = {
  "class": "md:flex md:flex-grow md:overflow-hidden"
};
var _hoisted_18 = {
  "class": "px-4 py-8 md:flex-1 md:p-12 md:overflow-y-auto",
  "scroll-region": ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_logo = _resolveComponent("logo");
  var _component_Link = _resolveComponent("Link");
  var _component_main_menu = _resolveComponent("main-menu");
  var _component_dropdown = _resolveComponent("dropdown");
  var _component_icon = _resolveComponent("icon");
  var _component_flash_messages = _resolveComponent("flash-messages");
  var _component_Loader = _resolveComponent("Loader");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_Link, {
    "class": "mt-1",
    href: "/"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_logo, {
        "class": "fill-white",
        width: "120",
        height: "28"
      })];
    }),
    _: 1
  }), _createVNode(_component_dropdown, {
    "class": "md:hidden",
    placement: "bottom-end"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_6];
    }),
    dropdown: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_7, [_createVNode(_component_main_menu)])];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_dropdown, {
    "class": "mt-1",
    placement: "bottom-end"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString($props.auth.user.first_name), 1), _createElementVNode("span", _hoisted_12, " " + _toDisplayString($props.auth.user.last_name), 1)]), _createVNode(_component_icon, {
        "class": "w-5 h-5 fill-gray-700 group-hover:fill-indigo-600 focus:fill-indigo-600",
        name: "cheveron-down"
      })])];
    }),
    dropdown: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_13, [_createVNode(_component_Link, {
        "class": "block px-6 py-2 hover:text-white hover:bg-indigo-500",
        href: "/users/".concat($props.auth.user.id, "/edit")
      }, {
        "default": _withCtx(function () {
          return [_hoisted_14];
        }),
        _: 1
      }, 8, ["href"]), _ctx.$store.can.users ? (_openBlock(), _createBlock(_component_Link, {
        key: 0,
        "class": "block px-6 py-2 hover:text-white hover:bg-indigo-500",
        href: "/users"
      }, {
        "default": _withCtx(function () {
          return [_hoisted_15];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_Link, {
        "class": "block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500",
        href: "/logout",
        method: "delete",
        as: "button"
      }, {
        "default": _withCtx(function () {
          return [_hoisted_16];
        }),
        _: 1
      })])];
    }),
    _: 1
  })])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_main_menu, {
    "class": "hidden flex-shrink-0 p-2 w-56 bg-indigo-800 overflow-y-auto md:block"
  }), _createElementVNode("div", _hoisted_18, [_createVNode(_component_flash_messages), _renderSlot(_ctx.$slots, "default")])])])])]), _createVNode(_component_Loader)], 64);
}